<template>
  <div v-if="open" class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-card exam-modal">
      <div class="exam-modal-head">
        <div>
          <h3>{{ subjectName || 'Exam schedule' }}</h3>
          <p v-if="projectName" class="sub">{{ projectName }}</p>
        </div>
        <button type="button" class="pm-x" @click="$emit('close')">×</button>
      </div>
      <dsa-loading v-if="loading" compact text="Loading exam schedule…" />
      <template v-else>
        <ul class="notes">
          <li>You may only enter the exam between Entry Open Time and Entry Close Time.</li>
          <li>The exam timer starts only when you enter, and you will have the full exam time from then on.</li>
        </ul>
        <div v-if="!sessions.length" class="empty-note">No exam sessions are configured for this subject yet.</div>
        <div v-else class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Exam Name</th>
                <th>Exam Type</th>
                <th>Time to Exam</th>
                <th>Exam Open Time</th>
                <th>Exam Close Time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, idx) in sessions" :key="idx">
                <td>{{ row.exam_name || '—' }}</td>
                <td>{{ row.exam_type || '—' }}</td>
                <td>{{ timeToExam(row) }}</td>
                <td>{{ row.exam_open_time || '—' }}</td>
                <td>{{ row.exam_close_time || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="actions">
          <button type="button" class="btn btn-outline" @click="$emit('close')">Close</button>
          <a
            class="btn btn-primary"
            :href="examSystemUrl"
            target="_blank"
            rel="noopener noreferrer"
          >Go to exam system</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExamScheduleModal',
  props: {
    open: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    subjectName: { type: String, default: '' },
    projectName: { type: String, default: '' },
    sessions: { type: Array, default: () => [] },
    examSystemUrl: { type: String, default: 'https://exam.learningfirst.io/' },
  },
  methods: {
    timeToExam(row) {
      const open = Number(row && row.open_ts) || 0
      if (!open) return '—'
      const now = Math.floor(Date.now() / 1000)
      const diff = open - now
      if (diff <= 0) {
        const close = Number(row.close_ts) || 0
        if (close > 0 && now > close) return 'Closed'
        return 'Open now'
      }
      const days = Math.floor(diff / 86400)
      const hours = Math.floor((diff % 86400) / 3600)
      const mins = Math.floor((diff % 3600) / 60)
      if (days > 0) return `${days}d ${hours}h`
      if (hours > 0) return `${hours}h ${mins}m`
      return `${mins}m`
    },
  },
}
</script>

<style scoped>
.modal-overlay{position:fixed;inset:0;background:rgba(15,23,42,.45);z-index:90;display:flex;align-items:center;justify-content:center;padding:16px}
.exam-modal{background:#fff;border-radius:16px;width:min(860px,96vw);max-height:90vh;overflow:auto;padding:22px 24px;box-shadow:0 24px 60px rgba(15,40,80,.25)}
.exam-modal-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:14px}
.exam-modal-head h3{margin:0;font-size:17px;font-weight:700}
.exam-modal-head .sub{margin:4px 0 0;font-size:13px;color:var(--muted,#64748b)}
.pm-x{border:none;background:#eef1f5;color:#64748b;width:30px;height:30px;border-radius:50%;font-size:16px;cursor:pointer;line-height:1;flex-shrink:0}
.notes{margin:0 0 14px;padding-left:18px;font-size:13.5px;line-height:1.55;color:#334155}
.notes li{margin-bottom:6px}
.empty-note{font-size:13.5px;color:var(--muted,#64748b);padding:12px 0}
.table-wrap{overflow:auto;border:1px solid #e2e8f0;border-radius:10px}
.table-wrap table{width:100%;border-collapse:collapse;font-size:13px}
.table-wrap th,.table-wrap td{padding:10px 12px;text-align:left;border-bottom:1px solid #eef2f7;white-space:nowrap}
.table-wrap th{background:#f8fafc;font-weight:600;color:#475569;font-size:12px}
.table-wrap tr:last-child td{border-bottom:none}
.actions{display:flex;justify-content:flex-end;gap:10px;margin-top:18px;flex-wrap:wrap}
.btn{display:inline-flex;align-items:center;justify-content:center;border-radius:8px;padding:10px 16px;font-size:13.5px;font-weight:600;cursor:pointer;text-decoration:none;border:1px solid transparent}
.btn-primary{background:#185FA5;color:#fff}
.btn-outline{background:#fff;border-color:#cbd5e1;color:#185FA5}
</style>
